import fetch from 'api/fetch'

/**
 * 根据skuId、money获取分期信息
 * @param {Object} params - 包含skuId属性,money属性.
 */
export function getInstallmentReq({ skuId, money }) {
  return fetch({
    url: '/product/getInstallmentDetail',
    params: {
      skuId,
      money
    }
  })
}
